import React, { createContext, useContext, useMemo, useState } from 'react';
import {
  DEFAULT_PLAN_ID,
  getPlanById,
  PLANS,
  SUBSCRIPTION_STORAGE_KEY,
} from '../subscription/subscriptionConfig';

const SubscriptionContext = createContext(null);

function readInitialPlan() {
  const storedPlan = localStorage.getItem(SUBSCRIPTION_STORAGE_KEY);
  return PLANS[storedPlan] ? storedPlan : DEFAULT_PLAN_ID;
}

export function SubscriptionProvider({ children }) {
  const [planId, setPlanId] = useState(readInitialPlan);

  const value = useMemo(() => {
    const currentPlan = getPlanById(planId);

    const updatePlan = (nextPlanId) => {
      const normalized = PLANS[nextPlanId] ? nextPlanId : DEFAULT_PLAN_ID;
      setPlanId(normalized);
      localStorage.setItem(SUBSCRIPTION_STORAGE_KEY, normalized);
    };

    const hasFeature = (featureKey) => !!currentPlan.features?.[featureKey];

    return {
      planId,
      planLabel: currentPlan.label,
      plan: currentPlan,
      hasFeature,
      updatePlan,
    };
  }, [planId]);

  return <SubscriptionContext.Provider value={value}>{children}</SubscriptionContext.Provider>;
}

export function useSubscription() {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscription must be used within SubscriptionProvider');
  }
  return context;
}
